export const LEADERBOARD_TYPE_DEFAULT = '';
export const LEADERBOARD_TYPE_TOP_USERS = 'topUsers';

export const LEADERBOARD_TYPES = [
    LEADERBOARD_TYPE_DEFAULT,
    LEADERBOARD_TYPE_TOP_USERS,
];
